import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { useHistory, useLocation } from 'react-router';
import verifyWithAppleStore from '../../../stores/VerifyWithAppleStore';
import userStore from '../../../stores/User';
import SocialLoginStore from '../../../stores/SocialLoginStore';
import registerWithAppleCallbackStore from '../../../stores/RegisterWithAppleCallback';
import csrfTokenStore from '../../../stores/CsrfToken';
import { Button, CircularProgress, Container, Stack, Typography } from '@mui/material';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AppleCallback = () => {

  const history = useHistory();
  const query = useQuery();
  const user = userStore();
  const csrfToken = csrfTokenStore();
  const verifyStore = verifyWithAppleStore();
  const appleCallback = registerWithAppleCallbackStore();
  const socialLogin = SocialLoginStore();

  useEffect(() => {
    const state = query.get("state");
    const code = query.get("code");
    console.log("state", state)
    console.log("code", code)
    if ( code && state === csrfToken.appleState ) {
      verifyStore.verify(code);
    } else {
      verifyStore.setError(true, "Login failed");
    }

    return () => {
      verifyStore.clearAll();
    };
  }, [])

  useEffect(() => {
    if (verifyStore.result) {
      const { status } = verifyStore.result;
      if (status === "login_success") {
        user.setAccessToken(verifyStore.result.accessToken);
        user.setProfile(verifyStore.result.user);
        back();
      } else if (status === "verify_success") {
        goToRegisterPage();
      } else {
        verifyStore.setError(true, "Login failed");
      }
    }
  }, [verifyStore.result])

  const goToRegisterPage = () => {
    const { appleId, email, firstname, lastname, accessToken } = verifyStore.result;
    appleCallback.setData(
      appleId,
      accessToken,
      email,
      firstname,
      lastname,
    );
    history.push('/register/apple');
  }

  const back = () => {
    const targetPath = socialLogin.targetPath;
    history.push(targetPath || '/');
  }

  return (
    <Container
        sx={{ 
          height: '100vh',
          padding: '0px'
        }}
      >
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{ 
          height: '100vh',
          padding: '0px'
        }}
      >
        { verifyStore.isLoading && <CircularProgress /> }
        {
          verifyStore.hasError !== null && 
          <>
            <Typography variant="h3">{ verifyStore.errorMessage }</Typography>
            <Button
              variant="outlined" 
              className="my-4 normal-case text-base border-gray-400 text-black-normal text-lg font-medium"
              onClick={back}
            >
              Back
            </Button>
          </>
        }
      </Stack>
    </Container>
  );
}

export default AppleCallback;